import { render, staticRenderFns } from "./LivePodRestarts.vue?vue&type=template&id=54ef0699&scoped=true&"
import script from "./LivePodRestarts.vue?vue&type=script&lang=js&"
export * from "./LivePodRestarts.vue?vue&type=script&lang=js&"
import style0 from "./LivePodRestarts.vue?vue&type=style&index=0&id=54ef0699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef0699",
  null
  
)

export default component.exports